export default __webpack_public_path__ + "atomic/_patterns/02-molecules/newsletter_form/_newsletter_form.twig";